import "StyleModules/saxon-advisors.lazy.scss";
import React from "react";
import PropTypes from "prop-types";
import { uuid } from "Utils/utils";
import Divider from "../../universal/Divider";
import ServiceCard from "./ServiceCard";
import AnalaystCard from "./AnalaystCard";
import classNames from "classnames";
import LearnMoreBtn from "./LearnMoreBtn";
import useMediaQuery from "@mui/material/useMediaQuery";
import Timeline from "@mui/lab/Timeline";
import TimelineItem from "@mui/lab/TimelineItem";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import TimelineConnector from "@mui/lab/TimelineConnector";
import TimelineContent from "@mui/lab/TimelineContent";
import TimelineDot from "@mui/lab/TimelineDot";

const Advisors = ({ stats, clients, services, contact }) => {
	const lgAndUp = useMediaQuery(theme.breakpoints.up("xl"));
	const getBorder = (index, array) => {
		if (index + 1 != array.length && !lgAndUp) {
			return "border-bottom border-secondary pb-2";
		}
		if (index + 1 != array.length && lgAndUp) {
			return "border-end border-secondary pr-2";
		}
		return "";
	};

	return (
		<>
			<Divider />
			<section className="container-fluid container-lg d-flex justify-content-center flex-column py-5 px-2">
				<div className="row py-3">
					<div className="col-12">
						<div className="row">
							<div className="col-12 d-flex flex-column justify-content-center align-items-center">
								<h5 className="text-info my-2 text-uppercase">{clients.subtitle}</h5>
								<h1 className="display-5 fw-700 text-snow text-center my-3" data-aos="fade-up">
									{clients.title}
								</h1>
								<p className="fs-4 fw-300 text-muted lead mb-3" data-aos="fade-up">
									{stats.description}
								</p>
								<div className="grid mt-4 mb-3" data-aos="fade-up">
									{stats.items.map((item) => (
										<div className="g-col-12 g-col-md-4 fs-5 ff-sans-serif-alt" key={uuid()}>
											<div className="d-flex flex-column align-items-center justify-content-center">
												<h1 className="fs-3 fw-700 text-info mb-0 d-inline ff-sans-serif-alt">
													<span data-countup={item.data} data-to={item.to} data-aos data-aos-id="countup:in">
														0
													</span>
												</h1>
												<p className="text-gray-700 mb-0">{item.name}</p>
											</div>
										</div>
									))}
								</div>
								<div className="grid mt-5 w-100">
									{clients.items.map((item, index) => (
										<div
											className="g-col-6 g-col-md-4 g-col-lg-3 d-flex align-items-center justify-content-center p-3 text-center my-2"
											data-aos="fade-up"
											data-aos-delay={index * 150}
											data-aos-offset={20}
											key={uuid()}>
											<img
												src={item.img}
												alt={item.alt}
												longdesc={item.longdesc}
												className="img-fluid text-snow align-self-center grow-lg"
												style={{ width: "75%", height: "100%", objectFit: "contain" }}
											/>
										</div>
									))}
									<div
										className="g-col-12 d-flex align-items-center justify-content-center py-2 text-center"
										data-aos="fade-up"
										data-aos-delay={clients.items.length * 150}
										data-aos-offset={20}>
										<p className="text-center h4" data-aos="fade-up">
											...and many more.
										</p>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>

			<Divider />
			<section className="py-5 container-fluid container-lg position-relative px-2">
				<div className="text-center">
					<h5 className="text-info my-2 text-uppercase">{services.subtitle}</h5>
					<h1 className="display-6 fw-600 text-white mt-3 mb-4">{services.title}</h1>
				</div>
				<div className="" style={{ textAlign: "justify" }}>
					<p className="fs-4 fw-200 text-light lead mb-3">
						{services.descriptionItems.map((item, index) => (
							<span data-aos="fade-up" data-aos-delay={index * 150} data-aos-offset={20} key={uuid()}>
								{item}
							</span>
						))}
					</p>
					<h3 className="fw-200 text-light"></h3>
				</div>
				<div
					className=""
					// style={{ "--bs-columns": 2, "--bs-gap": "2rem" }}
				>
					<Timeline position="right" sx={{ px: 0 }}>
						{services.items.map((item, index) => (
							<TimelineItem key={uuid()}>
								<TimelineSeparator>
									<TimelineDot sx={{ backgroundColor: "transparent", boxShadow: "none", p: 0, marginTop: 1 }}>
										<i className={classNames("mdi", `mdi-numeric-${index + 1}-circle mdi-24px text-info fs-2`)} />
									</TimelineDot>
									<TimelineConnector className="bg-sleet" />
								</TimelineSeparator>
								<TimelineContent>
									<div className="d-flex align-items-center pb-3" data-aos={"fade-left"} data-aos-delay={(index + 1) * 100} key={uuid()}>
										<ServiceCard item={item} stepNumber={index + 1} />
									</div>
								</TimelineContent>
							</TimelineItem>
						))}
					</Timeline>
				</div>
				<div className="text-center mt-3" data-aos="fade-up">
					<LearnMoreBtn />
				</div>
			</section>
			<Divider />
			<section className="py-5 container-fluid container-lg px-2">
				<div className="py-5">
					<div className="display-6 text-snow mb-4 fw-600 d-flex justify-content-center">{contact.title}</div>
					<div className="text-light fs-4 my-2 d-flex d-flex justify-content-center fw-200">
						<span>{contact.subtitle}</span>
					</div>
					<div className="grid my-5" style={{ "--bs-columns": 3, "--bs-gap": "1rem" }}>
						{contact.items.map((item, index, array) => (
							<div className={classNames("g-col-3 g-col-xl-1 d-flex align-items-center justify-content-start", getBorder(index, array))} data-aos="fade-up" key={uuid()}>
								<AnalaystCard {...item} />
							</div>
						))}
					</div>

					<div className="text-center " data-aos="fade-up">
						<LearnMoreBtn textContent="Contact Us" />
					</div>
				</div>
			</section>
			<Divider />
		</>
	);
};

Advisors.defaultProps = {
	introduction: window.SaxonData.Advisors.introduction || null,
	stats: window.SaxonData.Advisors.stats || null,
	clients: window.SaxonData.Advisors.clients || null,
	services: window.SaxonData.Advisors.services || null,
	contact: window.SaxonData.Advisors.contact || null,
};
Advisors.propTypes = {
	introduction: PropTypes.object,
	stats: PropTypes.object,
	clients: PropTypes.object,
	services: PropTypes.object,
	contact: PropTypes.object,
};

export default Advisors;
